import { getUptimePercent } from "./pciEosUtils";
import { useSummaryMetrics } from "reports/utils/metricUtils";
import { MetricEnum } from "reports/utils/metricTypes";
import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import SummaryMetrics from "../../../../components/Reports/SummaryMetrics";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export default function PciSummaryMetrics({
  data,
  processGroupName,
}: {
  data: PnlBreakdown;
  processGroupName?: string;
}) {
  // Specially calculated for PCI
  const uptimePercent = getUptimePercent(data);
  const reportConfig = useReportConfig();
  const customMetricsFromConfig = (
    reportConfig?.eosReportMetricsConfig?.summaryMetricsRow1 ?? []
  ).map(metric => ({
    ...metric,
    // patch in custom uptimePercent
    ...(metric.name === MetricEnum.UPTIME
      ? { customValue: uptimePercent }
      : {}),
  }));
  const summaryMetricsRow1 = useSummaryMetrics({
    metrics: customMetricsFromConfig ?? [
      { name: MetricEnum.OEE },
      { name: MetricEnum.AVAIL },
      { name: MetricEnum.PERF },
      { name: MetricEnum.UPTIME, customValue: uptimePercent },
      { name: MetricEnum.TAGGING },
    ],
    pnlBreakdown: data,
  });

  const summaryMetricsRow2 = useSummaryMetrics({
    metrics: reportConfig?.eosReportMetricsConfig?.summaryMetricsRow2 ?? [
      { name: MetricEnum.PRODUCTION_TIME },
      { name: MetricEnum.PRODUCING_TIME },
    ],
    pnlBreakdown: data,
  });

  return (
    <SummaryMetrics
      processGroupName={processGroupName}
      summaryMetrics={[summaryMetricsRow1, summaryMetricsRow2]}
    />
  );
}
